var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "bounse" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$store.state.snapTaskShow,
                expression: "$store.state.snapTaskShow"
              }
            ],
            staticClass: "snap-task",
            style: {
              height: 42 * _vm.items.length + 100 + "px",
              top:
                _vm.items.length <= 7
                  ? -42 * _vm.items.length - 115 + "px"
                  : -400 + "px"
            },
            attrs: { id: "snapTask" },
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", { staticClass: "title" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("language.popup.progressBox")))
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "icon scaling-close dialog-close",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.snapTaskShowClose()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "snap-body" }, [
              _c(
                "div",
                {
                  staticClass: "snap-content",
                  style: { height: 42 * _vm.items.length + 5 + "px" }
                },
                _vm._l(_vm.items, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "snap-transfer",
                      on: {
                        mouseover: function($event) {
                          _vm.hoverCurrent = index
                        },
                        mouseout: function($event) {
                          _vm.hoverCurrent = -1
                        }
                      }
                    },
                    [
                      !item.uploadData && item.percent
                        ? _c(
                            "div",
                            {
                              staticClass: "snap-transfer-name",
                              attrs: { title: item.name }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.transferring")) +
                                  ':"' +
                                  _vm._s(item.name) +
                                  '"'
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !item.uploadData && !item.percent
                        ? _c(
                            "div",
                            {
                              staticClass: "snap-transfer-name",
                              attrs: { title: item.name }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.ready")) +
                                  ':"' +
                                  _vm._s(item.name) +
                                  '"'
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.uploadData
                        ? _c(
                            "div",
                            {
                              staticClass: "snap-transfer-name",
                              attrs: { title: item.name }
                            },
                            [
                              _c("div", { staticStyle: { float: "left" } }, [
                                _c("div", { staticStyle: { float: "left" } }, [
                                  _vm._v("Upload:")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-name-txt",
                                    staticStyle: { float: "left" }
                                  },
                                  [_vm._v('"' + _vm._s(item.name) + '"')]
                                )
                              ]),
                              _vm._v(" "),
                              item.status == "failed"
                                ? _c(
                                    "div",
                                    { staticClass: "failed-transfer-name" },
                                    [_vm._v(_vm._s(item.status) + " ")]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "snap-progress" }, [
                        _c("div", {
                          class: [item.percent ? "snap-ground-start" : ""],
                          style: { width: item.percent + "%" }
                        })
                      ]),
                      _vm._v(" "),
                      item.percent <= 100 && !item.uploadData
                        ? _c("div", { staticClass: "snap-percentage" }, [
                            _vm._v(_vm._s(item.percent) + "%")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.percent > 100
                        ? _c("div", { staticClass: "snap-percentage" }, [
                            _vm._v("100.00%")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.percent && item.uploadData
                        ? _c("div", { staticClass: "snap-percentage" }, [
                            _vm._v(_vm._s(item.percent) + "%")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !item.percent && item.uploadData
                        ? _c("div", { staticClass: "snap-percentage" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.ready")) + "..."
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.percent == undefined && !item.uploadData
                        ? _c("div", { staticClass: "snap-percentage" }, [
                            _vm._v(
                              _vm._s(_vm.$t("language.common.ready")) + "..."
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.percent != 100
                        ? _c("div", {
                            staticClass: "icon-util snap-remove-position",
                            class: [
                              index == _vm.hoverCurrent ? "blue-remove" : ""
                            ],
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.removeItem(index, item)
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "snap-footer" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "icon-util question  explanShow snap-icon-position"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "snap-explanation" },
                      [
                        _c("font", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("language.cloudExploer.limitBoxTip")
                            )
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.items.length && _vm.$store.state.cancelAllFlag,
                        expression: "items.length&&$store.state.cancelAllFlag"
                      }
                    ],
                    staticClass: "snap-cancel",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.cancelAllItem()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.popup.cancel")))]
                ),
                _vm._v(" "),
                _vm.$store.state.detailedProgrssData.length
                  ? _c(
                      "button",
                      {
                        staticClass: "snap-detail",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.openDetailedProgress()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.popup.detailed")))]
                    )
                  : _vm._e()
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-503b198e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-503b198e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/snap_task_popup.vue
// module id = null
// module chunks = 